import Routes from './Routes/Routes'

export default function App() {
  return <Routes />;
}